import {Button, Spin, Table, message} from 'antd';
import {useEffect, useState} from 'react';
import {Course} from '../../graphql/API';
import {Link, useHistory} from 'react-router-dom';
import Title from 'antd/es/typography/Title';
// OLD CODE - Commented out (kept for reference)
// import {CoursesService} from '../Courses';
import { PlanTable } from './PlanTable';

// NEW CODE - Using @PikaDoApp/npm-pikado-logic
import {PlansService} from './PlansService';
import {CurriculumsService} from '../Curriculums/CurriculumsService';
import {LevelsService} from '../Level/LevelsService';

// OLD CODE - Commented out (kept for reference)
// const coursesService = new CoursesService();

// NEW CODE - Using @PikaDoApp/npm-pikado-logic
const plansService = new PlansService();
const curriculumsService = new CurriculumsService();
const levelsService = new LevelsService();

export const PlanTableContainer = () => {
  const history = useHistory();

  // OLD CODE - Commented out (kept for reference)
  // const [courses, setCourses] = useState<Array<any> | []>([]);
  // const [curriculumNames, setCurriculumNames] = useState<Array<any>  | []>([]);

  // NEW CODE - Using @PikaDoApp/npm-pikado-logic
  const [plans, setPlans] = useState<Array<any> | []>([]);
  const [groupedPlans, setGroupedPlans] = useState<Array<any> | []>([]);
  const [curriculumNames, setCurriculumNames] = useState<Array<any>  | []>([]);
  const [isError, setIsError] = useState<boolean>(false);
  const [isLoading, setIsLoading] = useState<boolean>(true);

  // OLD CODE - Commented out (kept for reference)
  // useEffect(() => {
  //   coursesService
  //     .getCourses()
  //     .then((resp) => {
  //       setIsLoading(false);
  //       const groupedByCourseName =  resp.reduce((acc, course,index) => {
  //         const courseName = course?.curriculum?.name;
  //
  // if (!acc[courseName]) {
  //   acc[courseName] = [];
  // }
  //
  // acc[courseName].push(course);
  //
  // return acc;
  //       }, {});
  //       setCourses(resp);
  //       let temp =Object.entries(groupedByCourseName).map(([key, value]) => value)
  //       let temp2 =Object.entries(groupedByCourseName).map(([key, value]) => key)
  //       setCourses([...temp])
  //       setCurriculumNames([...temp2])
  //     })
  //     .catch((error) => {
  //       setIsError(true);
  //       console.log('PlanTableContainer groupedByCourseName Error ->', error);
  //     });
  // }, []);

  // NEW CODE - Using @PikaDoApp/npm-pikado-logic
  useEffect(() => {
    const fetchAndPopulatePlans = async () => {
      try {
        console.log('🔍 [PLAN-CONTAINER] Fetching all plans');
        const plans = await plansService.findAllPlans();
        console.log('✅ [PLAN-CONTAINER] Plans fetched:', plans);

        // Extract unique curriculum IDs and level IDs
        const curriculumIds = [...new Set(plans.map(plan =>
          typeof plan.curriculum === 'string' ? plan.curriculum : null
        ).filter(Boolean))];

        const levelIds = [...new Set(plans.map(plan =>
          typeof plan.level === 'string' ? plan.level : null
        ).filter(Boolean))];

        console.log('🔍 [PLAN-CONTAINER] Fetching curriculum and level details', {curriculumIds, levelIds});

        // Fetch curriculum and level details
        const curriculumPromises = curriculumIds.map(id =>
          curriculumsService.getCurriculumById(id).catch(err => {
            console.error(`Failed to fetch curriculum ${id}:`, err);
            return null;
          })
        );

        const levelPromises = levelIds.map(id =>
          levelsService.getNewLevelById(id).catch(err => {
            console.error(`Failed to fetch level ${id}:`, err);
            return null;
          })
        );

        const [curriculums, levels] = await Promise.all([
          Promise.all(curriculumPromises),
          Promise.all(levelPromises)
        ]);

        // Create lookup maps
        const curriculumMap = new Map();
        curriculums.forEach((curriculum, index) => {
          if (curriculum) {
            curriculumMap.set(curriculumIds[index], curriculum);
          }
        });

        const levelMap = new Map();
        levels.forEach((level, index) => {
          if (level) {
            levelMap.set(levelIds[index], level);
          }
        });

        console.log('✅ [PLAN-CONTAINER] Curriculum and level details fetched', {curriculumMap, levelMap});

        // Enrich plans with populated curriculum and level objects
        const enrichedPlans = plans.map(plan => ({
          ...plan,
          curriculum: typeof plan.curriculum === 'string'
            ? curriculumMap.get(plan.curriculum) || plan.curriculum
            : plan.curriculum,
          level: typeof plan.level === 'string'
            ? levelMap.get(plan.level) || plan.level
            : plan.level
        }));

        setPlans(enrichedPlans);

        // Group plans by curriculum name
        const groupedByCurriculum = enrichedPlans.reduce((acc, plan) => {
          const curriculumName = typeof plan.curriculum === 'object'
            ? plan.curriculum?.name
            : plan.curriculum || 'No Curriculum';

          if (!acc[curriculumName]) {
            acc[curriculumName] = [];
          }

          acc[curriculumName].push(plan);

          return acc;
        }, {});

        const grouped = Object.entries(groupedByCurriculum).map(([key, value]) => value);
        const names = Object.entries(groupedByCurriculum).map(([key, value]) => key);

        setGroupedPlans([...grouped]);
        setCurriculumNames([...names]);
        console.log('✅ [PLAN-CONTAINER] Plans grouped by curriculum:', {grouped, names});
        setIsLoading(false);
      } catch (error) {
        setIsError(true);
        console.error('❌ [PLAN-CONTAINER] Error fetching plans:', error);
        setIsLoading(false);
      }
    };

    fetchAndPopulatePlans();
  }, []);

  const handleDelete = async (id: string) => {
    try {
      setIsLoading(true);
      await plansService.deletePlan(id);
      message.success('Plan deleted successfully');

      // Refresh the plans list with populated data
      const plans = await plansService.findAllPlans();

      // Extract unique curriculum IDs and level IDs
      const curriculumIds = [...new Set(plans.map(plan =>
        typeof plan.curriculum === 'string' ? plan.curriculum : null
      ).filter(Boolean))];

      const levelIds = [...new Set(plans.map(plan =>
        typeof plan.level === 'string' ? plan.level : null
      ).filter(Boolean))];

      // Fetch curriculum and level details
      const curriculumPromises = curriculumIds.map(id =>
        curriculumsService.getCurriculumById(id).catch(err => {
          console.error(`Failed to fetch curriculum ${id}:`, err);
          return null;
        })
      );

      const levelPromises = levelIds.map(id =>
        levelsService.getNewLevelById(id).catch(err => {
          console.error(`Failed to fetch level ${id}:`, err);
          return null;
        })
      );

      const [curriculums, levels] = await Promise.all([
        Promise.all(curriculumPromises),
        Promise.all(levelPromises)
      ]);

      // Create lookup maps
      const curriculumMap = new Map();
      curriculums.forEach((curriculum, index) => {
        if (curriculum) {
          curriculumMap.set(curriculumIds[index], curriculum);
        }
      });

      const levelMap = new Map();
      levels.forEach((level, index) => {
        if (level) {
          levelMap.set(levelIds[index], level);
        }
      });

      // Enrich plans with populated curriculum and level objects
      const enrichedPlans = plans.map(plan => ({
        ...plan,
        curriculum: typeof plan.curriculum === 'string'
          ? curriculumMap.get(plan.curriculum) || plan.curriculum
          : plan.curriculum,
        level: typeof plan.level === 'string'
          ? levelMap.get(plan.level) || plan.level
          : plan.level
      }));

      setPlans(enrichedPlans);

      // Re-group plans by curriculum
      const groupedByCurriculum = enrichedPlans.reduce((acc, plan) => {
        const curriculumName = typeof plan.curriculum === 'object'
          ? plan.curriculum?.name
          : plan.curriculum || 'No Curriculum';

        if (!acc[curriculumName]) {
          acc[curriculumName] = [];
        }

        acc[curriculumName].push(plan);
        return acc;
      }, {});

      const grouped = Object.entries(groupedByCurriculum).map(([key, value]) => value);
      const names = Object.entries(groupedByCurriculum).map(([key, value]) => key);

      setGroupedPlans([...grouped]);
      setCurriculumNames([...names]);
      setIsLoading(false);
    } catch (error) {
      message.error('Failed to delete plan');
      console.error('❌ [PLAN-CONTAINER] Delete error:', error);
      setIsLoading(false);
    }
  };

  return (
    <>
    <div style={{display: 'flex', justifyContent: 'end',minWidth:"100%"}}>

      <Button
        size={'large'}
        onClick={() => history.push('/plans/create')}>
        Create
      </Button>
    </div>
  {/* OLD CODE - Commented out (kept for reference) */}
  {/* {courses?.map((course,index)=> <div style={{padding:"1rem",marginBottom:"2rem"}}><PlanTable key={index} data={course} title={curriculumNames[index]} language={course[0]?.language?.language}/> </div> )} */}

  {/* NEW CODE - Using @PikaDoApp/npm-pikado-logic */}
  {groupedPlans?.map((planGroup, index) => (
    <div key={index} style={{padding:"1rem",marginBottom:"2rem"}}>
      <PlanTable
        data={planGroup}
        title={curriculumNames[index]}
        language={'N/A'}
        onDelete={handleDelete}
      />
    </div>
  ))}

      {isLoading && (
        <Spin size="large" style={{margin: 'auto', width: '100%'}} />
      )}
      {isError && <Title>Plans fetching error ⚠️</Title>}
    </>
  );
};
